import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ContractSearchPanel from '../components/ContractSearchPanel'; // [CT_SEARCH_V1] 검색 패널

export default function ContractList() {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [searching, setSearching] = useState(false); // [CT_SEARCH_V1] true = 검색결과 보는 중 → 아래 기본 목록 숨김

  useEffect(() => {
    checkAdmin();
    fetchContracts();
  }, []);

  // ★ 관리자 확인
  const checkAdmin = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/auth/me', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.data && response.data.grade === 'admin') {
        setIsAdmin(true);
      }
    } catch (error) {
      console.log('관리자 확인 실패');
    }
  };

  // ★ 계약서 목록 조회
  const fetchContracts = async () => {
    try {
      const response = await axios.get('/api/contracts/');
      if (response.data.success) {
        setContracts(response.data.data);
      }
    } catch (error) {
      console.error('계약서 목록 조회 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>📋 계약서 목록</h1>
        
        {/* ★ 등록 버튼 */}
        <button
          onClick={() => {
            window.location.href = '/contracts/new';
          }}
          style={{
            backgroundColor: '#9333ea', color: 'white', border: 'none',
            padding: '10px 20px', borderRadius: '4px', cursor: 'pointer',
            fontSize: '14px', fontWeight: 'bold', marginRight: '8px',
          }}
        >
          ✍️ 직접 입력
        </button>
        <button
          onClick={() => {
            window.location.href = '/contracts/batch';
          }}
          style={{
            backgroundColor: '#2196F3', color: 'white', border: 'none',
            padding: '10px 20px', borderRadius: '4px', cursor: 'pointer',
            fontSize: '14px', fontWeight: 'bold', marginRight: '8px',
          }}
        >
          📚 일괄 등록
        </button>
        <button
          onClick={() => {
            window.location.href = '/contracts/upload';
          }}
          style={{
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          ➕ 새 계약서 등록
        </button>
      </div>
      
      <ContractSearchPanel onActiveChange={setSearching} />

      {searching ? null : loading ? (
        <div>로딩 중...</div>
      ) : contracts.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
          등록된 계약서가 없습니다.
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
              <th style={{ padding: '12px', textAlign: 'left' }}>계약ID</th>
              <th style={{ padding: '12px', textAlign: 'left' }}>유형</th>
              <th style={{ padding: '12px', textAlign: 'left' }}>주소</th>
              <th style={{ padding: '12px', textAlign: 'left' }}>계약날짜</th>
              <th style={{ padding: '12px', textAlign: 'left' }}>등록일</th>{/* [CT_REGDATE_V1] */}
              {isAdmin && <th style={{ padding: '12px', textAlign: 'center' }}>관리</th>}
            </tr>
          </thead>
          <tbody>
            {contracts.map((c) => (
              <tr 
                key={c.contract_id} 
                style={{ 
                  borderBottom: '1px solid #eee',
                  cursor: 'pointer',
                  backgroundColor: 'white',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9f9f9'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                onClick={() => {
                  window.location.href = `/contracts/${c.contract_id}`;
                }}
              >
                <td style={{ padding: '12px' }}>{c.contract_id}</td>
                <td style={{ padding: '12px' }}>
                  {c.contract_type === 'SALE' && '🏠 매매'}
                  {c.contract_type === 'RENT_TENANT' && '🔑 임차'}
                  {c.contract_type === 'RENT_LANDLORD' && '🏘️ 임대'}
                </td>
                <td style={{ padding: '12px' }}>{c.location_full_address}{/* [CT_WARN_V1] 확인 필요 — 마우스를 올리면 사유 */}{Array.isArray(c.warnings) && c.warnings.length > 0 && (<span title={c.warnings.join('\n')} style={{ marginLeft: 6, padding: '1px 7px', borderRadius: 10, background: '#fff3cd', color: '#8a6d00', fontSize: 12, whiteSpace: 'nowrap' }}>⚠️ {c.warnings.length}</span>)}</td>
                <td style={{ padding: '12px' }}>{c.contract_date?.split('T')[0]}</td>
                <td style={{ padding: '12px', color: '#888' }}>{String(c.created_at || '').slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  // ★ 삭제 함수
  async function deleteContract(contractId) {
    try {
      const response = await axios.delete(`/api/contracts/${contractId}`);
      if (response.data.success) {
        alert('삭제되었습니다');
        setContracts(contracts.filter(c => c.contract_id !== contractId));
      }
    } catch (error) {
      alert('삭제 실패: ' + error.message);
    }
  }
}